import { getAnalytics } from '@/services/analytics';

export function useAnalytics() {
  const analytics = getAnalytics();

  return {
    setUserId: analytics.setUserId.bind(analytics),
    setUserProperties: analytics.setUserProperties.bind(analytics),
    trackPageview: analytics.trackPageview.bind(analytics),
    trackEvent: analytics.trackEvent.bind(analytics),
  };
}
